// Boost Blenz Admin — theme tokens & context.
// Single deep-purple dark theme from the Daily Pulse redesign handoff
// (design_handoff_daily_pulse, 2026-07). The old Clean/Brand/Dark switcher was
// removed per owner: one scheme, dark only. If a light mode is ever wanted,
// re-introduce a THEMES map + switcher then.
// Oswald caps for section titles, Figtree for body/numbers, orange/purple accents.

import React from "react";

export const OSWALD = '"Oswald","Arial Narrow",sans-serif';
export const FIGTREE = '"Figtree","Helvetica Neue",Arial,sans-serif';
export const MONO = '"SFMono-Regular",ui-monospace,"JetBrains Mono",Menlo,monospace';

// ---------------- THEME (design tokens from the handoff README) ----------------
export const THEME: any = {
  id: 'dark', label: 'Dark',
  appBg: '#0d0a1e',                 // app/root black-purple
  mainBg: '#14102b',                // content backdrop base (textured layer in App.tsx)
  surface: '#1d1740',               // card surface
  surface2: '#17122f',              // inset / nested surface
  heroGrad: 'linear-gradient(160deg,#2a2154,#1f1943)', // Business Vitals hero cards
  sidebar: 'linear-gradient(180deg,#1b1440 0%,#160f34 100%)',
  sidebarFg: '#f4f1ff', sidebarMuted: '#b3a9d6', sidebarActive: '#f8925c',
  fg: '#f4f1ff', fg2: '#cfc6ee', muted: '#a99fce', faint: '#6f6592',
  border: 'rgba(150,130,230,0.13)', borderStrong: 'rgba(150,130,230,0.30)',
  accent: '#f8925c', accentSoft: 'rgba(248,146,92,0.16)',
  purple: '#b9a9ff', purpleSoft: 'rgba(185,169,255,0.16)',
  good: '#6fe3a0', goodSoft: 'rgba(87,217,138,0.15)',
  warn: '#ffce5a', warnSoft: 'rgba(255,206,90,0.14)',
  bad: '#ff8b7d', badSoft: 'rgba(255,111,94,0.16)',
  claude: '#b9a9ff', claudeSoft: 'rgba(185,169,255,0.14)', claudeBg: '#1c1934',
  cardRadius: 18, tileRadius: 12, shadow: 'none',
};

export const ThemeContext = React.createContext<any>(THEME);
export const useT = () => React.useContext(ThemeContext);

// responsive helper — true when viewport is phone/narrow-tablet width
export function useIsMobile(bp = 900) {
  const [m, setM] = React.useState(() => (typeof window !== 'undefined' ? window.innerWidth < bp : false));
  React.useEffect(() => {
    const on = () => setM(window.innerWidth < bp);
    window.addEventListener('resize', on); on();
    return () => window.removeEventListener('resize', on);
  }, [bp]);
  return m;
}
